import DefaultContainer from '../default_container';
import './index.css';
import constants from '../../constants';
const CouponsList = () => {
  return (
    <DefaultContainer isWelcomeMessage={false}>
      <div className="coupons_list_wrapper">
        <div className="coupons_pills_wrapper">
          <div className="my_coupons_list">My Coupon List</div>
        </div>
        <div className="coupons_card_wrapper">
          <div className="coupons_card_container">
            <div className="coupons_img_container">
              <img src={constants.Images.couponsListBg} className="coupons_img" />
            </div>

            <div className="coupons_details_container">
              <p>Date: 02-01-2023</p>

              <p className="coupons_title">Netflix Special coupons</p>
              <p>1. Must be a new user.</p>
              <p>2. coupons valid till Sep 25th, 2022</p>
            </div>

            <div className="coupons_amount_container">
              <img src={constants.Images.Wallet} className="coupons_wallet_img" width="15%" />
              <p style={{ paddingLeft: '2%' }}>3250</p>
            </div>
            <div className="coupons_redeem_btn_container">
              <div className="coupon_code_txt">
                <p>NETFLIX COUP-FJD-CDF</p>
              </div>
              <button className="coupons_copy_btn">Copy</button>
            </div>
          </div>
          <div className="coupons_card_container">
            <div className="coupons_img_container">
              <img src={constants.Images.couponsListBg} className="coupons_img" />
            </div>

            <div className="coupons_details_container">
              <p>Date: 02-01-2023</p>

              <p className="coupons_title">Netflix Special coupons</p>
              <p>1. Must be a new user.</p>
              <p>2. coupons valid till Sep 25th, 2022</p>
            </div>

            <div className="coupons_amount_container">
              <img src={constants.Images.Wallet} className="coupons_wallet_img" width="15%" />
              <p style={{ paddingLeft: '2%' }}>3250</p>
            </div>
            <div className="coupons_redeem_btn_container">
              <div className="coupon_code_txt">
                <p>NETFLIX COUP-FJD-CDF</p>
              </div>
              <button className="coupons_copy_btn">Copy</button>
            </div>
          </div>
          <div className="coupons_card_container">
            <div className="coupons_img_container">
              <img src={constants.Images.couponsListBg} className="coupons_img" />
            </div>

            <div className="coupons_details_container">
              <p>Date: 02-01-2023</p>

              <p className="coupons_title">Netflix Special coupons</p>
              <p>1. Must be a new user.</p>
              <p>2. coupons valid till Sep 25th, 2022</p>
            </div>

            <div className="coupons_amount_container">
              <img src={constants.Images.Wallet} className="coupons_wallet_img" width="15%" />
              <p style={{ paddingLeft: '2%' }}>3250</p>
            </div>
            <div className="coupons_redeem_btn_container">
              <div className="coupon_code_txt">
                <p>NETFLIX COUP-FJD-CDF</p>
              </div>
              <button className="coupons_copy_btn">Copy</button>
            </div>
          </div>
          <div className="coupons_card_container">
            <div className="coupons_img_container">
              <img src={constants.Images.couponsListBg} className="coupons_img" />
            </div>

            <div className="coupons_details_container">
              <p>Date: 02-01-2023</p>

              <p className="coupons_title">Netflix Special coupons</p>
              <p>1. Must be a new user.</p>
              <p>2. coupons valid till Sep 25th, 2022</p>
            </div>

            <div className="coupons_amount_container">
              <img src={constants.Images.Wallet} className="coupons_wallet_img" width="15%" />
              <p style={{ paddingLeft: '2%' }}>3250</p>
            </div>
            <div className="coupons_redeem_btn_container">
              <div className="coupon_code_txt">
                <p>NETFLIX COUP-FJD-CDF</p>
              </div>
              <button className="coupons_copy_btn">Copy</button>
            </div>
          </div>
          <div className="coupons_card_container">
            <div className="coupons_img_container">
              <img src={constants.Images.couponsListBg} className="coupons_img" />
            </div>

            <div className="coupons_details_container">
              <p>Date: 02-01-2023</p>

              <p className="coupons_title">Netflix Special coupons</p>
              <p>1. Must be a new user.</p>
              <p>2. coupons valid till Sep 25th, 2022</p>
            </div>

            <div className="coupons_amount_container">
              <img src={constants.Images.Wallet} className="coupons_wallet_img" width="15%" />
              <p style={{ paddingLeft: '2%' }}>3250</p>
            </div>
            <div className="coupons_redeem_btn_container">
              <div className="coupon_code_txt">
                <p>NETFLIX COUP-FJD-CDF</p>
              </div>
              <button className="coupons_copy_btn">Copy</button>
            </div>
          </div>
          <div className="coupons_card_container">
            <div className="coupons_img_container">
              <img src={constants.Images.couponsListBg} className="coupons_img" />
            </div>

            <div className="coupons_details_container">
              <p>Date: 02-01-2023</p>

              <p className="coupons_title">Netflix Special coupons</p>
              <p>1. Must be a new user.</p>
              <p>2. coupons valid till Sep 25th, 2022</p>
            </div>

            <div className="coupons_amount_container">
              <img src={constants.Images.Wallet} className="coupons_wallet_img" width="15%" />
              <p style={{ paddingLeft: '2%' }}>3250</p>
            </div>
            <div className="coupons_redeem_btn_container">
              <div className="coupon_code_txt">
                <p>NETFLIX COUP-FJD-CDF</p>
              </div>
              <button className="coupons_copy_btn">Copy</button>
            </div>
          </div>
          <div className="coupons_card_container">
            <div className="coupons_img_container">
              <img src={constants.Images.couponsListBg} className="coupons_img" />
            </div>

            <div className="coupons_details_container">
              <p>Date: 02-01-2023</p>

              <p className="coupons_title">Netflix Special coupons</p>
              <p>1. Must be a new user.</p>
              <p>2. coupons valid till Sep 25th, 2022</p>
            </div>

            <div className="coupons_amount_container">
              <img src={constants.Images.Wallet} className="coupons_wallet_img" width="15%" />
              <p style={{ paddingLeft: '2%' }}>3250</p>
            </div>
            <div className="coupons_redeem_btn_container">
              <div className="coupon_code_txt">
                <p>NETFLIX COUP-FJD-CDF</p>
              </div>
              <button className="coupons_copy_btn">Copy</button>
            </div>
          </div>
          <div className="coupons_card_container">
            <div className="coupons_img_container">
              <img src={constants.Images.couponsListBg} className="coupons_img" />
            </div>

            <div className="coupons_details_container">
              <p>Date: 02-01-2023</p>

              <p className="coupons_title">Netflix Special coupons</p>
              <p>1. Must be a new user.</p>
              <p>2. coupons valid till Sep 25th, 2022</p>
            </div>

            <div className="coupons_amount_container">
              <img src={constants.Images.Wallet} className="coupons_wallet_img" width="15%" />
              <p style={{ paddingLeft: '2%' }}>3250</p>
            </div>
            <div className="coupons_redeem_btn_container">
              <div className="coupon_code_txt">
                <p>NETFLIX COUP-FJD-CDF</p>
              </div>
              <button className="coupons_copy_btn">Copy</button>
            </div>
          </div>
        </div>
      </div>
    </DefaultContainer>
  );
};

export default CouponsList;
